import { load, save } from '../storage'

let nextId = 1

const state = load('tryout') || { tryouts: [] }

export default {
  namespaced: true,

  state,

  mutations: {
    ADD(state, tryout) {
      state.tryouts = [
        ...state.tryouts,
        { ...tryout, id: nextId.toString() },
      ].sort((a, b) => {
        if (a.type === b.type) return 0

        if (a.type === 'stretch') return -1

        if (a.type === 'target') {
          if (b.type === 'stretch') return 1
          return -1
        }

        if (a.type === 'safety') return 1

        return 0
      })

      nextId += 1
    },

    REMOVE(state, id) {
      state.tryouts = state.tryouts.filter(t => t.id !== id)
    },

    UPDATE(state, tryout) {
      const index = state.tryouts.findIndex(t => t.id === tryout.id)
      if (index === -1) return
      state.tryouts = [
        ...state.tryouts.slice(0, index),
        tryout,
        ...state.tryouts.slice(index + 1),
      ]
    },
  },

  actions: {
    addOrUpdate(context, tryout) {
      if (tryout.id) {
        context.commit('UPDATE', tryout)
      } else {
        context.commit('ADD', tryout)
      }

      save('tryout', context)
    },

    remove(context, id) {
      context.commit('REMOVE', id)

      save('tryout', context)
    },
  },

  getters: {
    get: state => id => state.tryouts.find(t => t.id === id),
  },
}
